import _ from "lodash";
import React from "react";
import classes from "./Levels.scss";
import TopHeader from "./TopHeader";
import { connect } from "react-redux";
import update from "immutability-helper";
import {
  getPlannerElementNodesOfSetQuery,
  getOrganizationGradeBasicDetailsQuery,
  getSubjectBenchmarksQuery,
  getATLsQuery,
} from "modules/CommonQuery";
import {
  getPlannerElementNodesOfSetFromCache,
  getOrganizationBasicGradeDetailsFromCache,
  getSubjectBenchmarksFromCache,
  getATLsFromCache,
} from "modules/CommonGraphqlHelpers";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { setGlobalTrayEnabledState } from "Login/modules/LoginModule";
import { goToBack } from "modules/NavigationModule";
import withLoader from "UIComponents/GqlWithLoader";
import Loading from "UIComponents/Loading";
import I18nHOC from "UIComponents/I18nHOC";
import LockedScreenWrapper from "UIComponents/LockedScreenComponents";
import { graphql, compose } from "lib/apolloClient";
import LevelEditor from "./LevelEditor";
import NodeTreeEditor from "./NodeTreeEditor";
import ACLStore from "lib/aclStore";
import { isFeatureLocked } from "modules/PermissionModule";
import { getPYPElementSetFromNodes } from "Utils";
import {
  getLevelsProps,
  getCombinedNodes,
  addGradesToNodes,
  modifyNodeDepthByNodeType,
  getTabsMemoize,
  getUpdatedRootNodeMemoize,
  mergeSelectedNodesMemoize,
  orderBySequenceNodesMemoize,
  updateSelectedNodesTypeMemoize,
  getStartDepth,
  getShowOutlineStatus,
} from "../Utils";
// TODO: Named imports( putting in {} ) is causing withQueryParamsBasedInterface undefined
import withQueryParamsBasedInterface from "UIComponents/QueryParamsBasedInterfaceHOC";
import {
  goToRelativeRoute,
  hideIntercom,
  showIntercom,
} from "modules/Services";
import NodeEditor from "NodeEditor";
import {
  updateSubjectItem,
  updateSnsSettingsAction,
  resetNodeEditorState,
} from "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule";
import {
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  ELEMENT_TYPE_DP_SYLLABUS,
  ELEMENT_TYPE_DP_KNOWLEDGE_FRAMEWORK,
  ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  ELEMENT_TYPE_UNIT_PLAN,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  SHIFT_ENTER_SUBMIT_SHORTCUT,
} from "Constants/stringConstants";
import { getCurriculumProgramFreeStatus } from "Platform/modules/PlatformModule";
import { withRouter } from "react-router";
import classNames from "classnames";
import { Button, Modal } from "@toddle-edu/ds-web";
import { getDisabledOperationTooltip } from "Administrator/modules/AdministratorModule";
import { ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION } from "Constants/permissionConstants";
import { getIsAcademicSetupEnabledForCurriculum } from "AdminSettings/utils/AdminSettiingsMenuNodeUtils";
import {
  getSelectedCurriculumId,
  getCurriculumProgramIdFromCurrentAdminNavigationNode,
  getActiveTab,
} from "modules/CommonSelectors";

const styles = {
  modalBody: {
    padding: 0,
  },
};

class Levels extends React.PureComponent {
  constructor(props) {
    super(props);
    const { nodeType, rootNode, value, gradeFilters } = props;
    const rootGrades = _.get(rootNode, "grades", []);
    this.state = {
      levelId: "",
      mode: "view",
      gradeFilters: gradeFilters || rootGrades,
      showDetails: false,
      showLockScreen: false,
      selectedCount: value?.length || 0,
    };
  }

  componentDidMount = () => {
    // const { loginActiveTab } = this.props;
    const {
      isSetPreview,
      nodes,
      rootNode,
      showViewModeOnly = false,
      loginActiveTab,
      isDsComponent = false,
      setGlobalTrayEnabledState,
      hideIntercom,
    } = this.props;

    let mode = "view";
    if (loginActiveTab == "school-onboarding") {
      mode = showViewModeOnly ? "view" : mode;
    }
    this.onChangeMode(mode);
    if (!isSetPreview) {
      this.props.updateSubjectItem({ ...rootNode, id: rootNode.subject });
      this.props.updateSnsSettingsAction("SNS_DETAIL");
    }

    setGlobalTrayEnabledState(false);
    hideIntercom();
  };

  componentWillUnmount() {
    const { setGlobalTrayEnabledState, showIntercom } = this.props;
    setGlobalTrayEnabledState(true);
    showIntercom();
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { nodes, loginActiveTab, showViewModeOnly } = this.props;
    let mode = prevState.mode;
    if (["school-onboarding", "teacher"].includes(loginActiveTab)) {
      mode = showViewModeOnly ? "view" : mode;
    }
    if (prevState.mode != mode) {
      this.onChangeMode(mode);
    }
  };

  onTabChange = item => {
    this.setState({ levelId: item.value });
  };

  updateGradeFilters = filters => {
    const { organizationGrades } = this.props;
    const gradeFilters = [];
    const filterValues = filters["gradeFilters"];

    _.forEach(organizationGrades, item => {
      if (_.includes(filterValues, item.id)) {
        gradeFilters.push(item);
      }
    });
    this.setState({ gradeFilters: gradeFilters });
  };

  onBackConfirmClick = () => {
    const { onBackClick, goToBack } = this.props;

    if (onBackClick) {
      onBackClick();
    } else {
      goToBack();
      //goToRelativeRoute({ route: "../", type: "replace" });
    }
  };

  onBackClick = () => {
    const { mode } = this.state;
    const {
      loginActiveTab,
      goToRelativeRoute,
      isSetPreview,
      onBackClick,
    } = this.props;
    if (loginActiveTab == "school-onboarding") {
      if (isSetPreview) {
        onBackClick();
      } else {
        goToRelativeRoute({ route: "../" });
      }
    } else if (this.isShowNodeTree() && mode == "edit") {
      if (this.nodeTreeEditor) {
        this.nodeTreeEditor.onActionClick({ action: "DISCARD" });
      }
    } else {
      this.onBackConfirmClick();
    }
  };

  onConceptualUnderStandingCheckBoxClick = () => {
    if (this.nodeTreeEditor) {
      this.nodeTreeEditor.onConceptualUnderStandingCheckBoxClick();
    }
  };

  onChangeMode = mode => {
    const { tabs = [] } = this.props;
    const isLocked = isFeatureLocked("SNS_EDITOR");
    if (mode == "edit" && isLocked) {
      this.setState({ showLockScreen: true });
    } else {
      this.setState({ mode: mode });
      let firstTab = "";
      this.setState({ showDetails: false });
      if (mode == "edit") {
        firstTab = tabs[0];
      } else if (mode == "view") {
        if (tabs.length == 1) {
          firstTab = tabs[0];
        } else {
          firstTab = tabs[1];
        }
      }

      this.setState({ showDetails: true });
      if (firstTab) this.onTabChange(firstTab);
    }
  };

  isShowNodeTree = () => {
    const { isCurriculumProgramFree } = this.props;
    const { mode } = this.state;
    return isCurriculumProgramFree || mode == "view";
  };

  onSubmitClick = async ({ valuesToAdd, valuesToRemove, shouldCloseModal }) => {
    const { onSubmitClick, isTagging, nodes, rootNodes } = this.props;
    if (isTagging) {
      const taggedIds = this.getTaggedIds();
      onSubmitClick &&
        onSubmitClick({
          selections: taggedIds,
          nodes,
          rootNodes,
          valuesToAdd,
          valuesToRemove,
          shouldCloseModal,
        });
    } else {
      if (this.nodeTreeEditor) {
        this.nodeTreeEditor.onActionClick({ action: "SAVE" });
      }
    }
  };

  onSubmitClickV2 = async ({
    valuesToAdd,
    valuesToRemove,
    shouldCloseModal,
    taggedIds = [],
    nodes,
  }) => {
    const {
      onSubmitClick,
      isTagging,
      rootNodes,
      nodes: levelsNodes,
      nodeType,
    } = this.props;
    if (isTagging) {
      onSubmitClick &&
        onSubmitClick({
          selections: taggedIds,
          nodes: nodeType == "BENCHMARK" ? levelsNodes : nodes, // TEMPORARY: SOON TO CHANGE FOR BENCHMARK
          rootNodes,
          valuesToAdd,
          valuesToRemove,
          shouldCloseModal,
        });
    }
  };

  canRenderNewNodeEditor = () => {
    const {
      nodeType,
      openedFrom,
      isTagging,
      isNewPlannerElementEditor,
    } = this.props;
    const isNewBenchmark = nodeType === "BENCHMARK";
    const renderNewEditor = _.includes(
      ["UNIT_PLAN", "PROGRESS_REPORT"],
      openedFrom
    );

    return (
      (isNewPlannerElementEditor || isNewBenchmark) &&
      (!isTagging || renderNewEditor)
    );
  };

  getTaggedIds = () => {
    if (this.nodeTreeEditor) {
      return this.nodeTreeEditor.getTaggedIds();
    }
  };

  // It is used in ConfigureElement.js using ref (ProgressReport)
  getModalState = () => {
    if (this.nodeTreeEditor) {
      return this.nodeTreeEditor.getModalState();
    }
  };

  updateNodeTreeRef = ref => {
    this.nodeTreeEditor = ref;
    if (this.props.customRef) {
      this.props.customRef(ref);
    }
  };

  getDescriptionText = () => {
    const { nodeType, t } = this.props;
    return nodeType == "BENCHMARK" ? t("common:learning_standards") : "";
  };

  onCloseLockScreenModal = () => {
    this.setState({ showLockScreen: false });
  };

  updateSelectCount = count => {
    this.setState({ selectedCount: count });
  };

  render() {
    const {
      tabs,
      nodes,
      levels,
      rootNode,
      organizationGrades,
      nodeSet,
      loginActiveTab,
      nodeType,
      label,
      plannerElementSetTopLabel,
      isTagging,
      value,
      updateValueLocally,
      editRootNode,
      isAdmin,
      onClickChoose,
      isSetPreview,
      hideHeader,
      theme,
      uptoDepth,
      showSelectedCount,
      startDepth,
      showOutline,
      showSearchHeader,
      multiSelectConfig,
      nodeRenderType,
      showInsights,
      insightsData,
      nodeParentType,
      showEditButton = true,
      plannerElementSetConfig,
      shouldSaveOnUpdate, //if this flag is true then changes will save on real time (i.e. mutation will call on onCheck)
      showGrade, // if this flag is false than grade filter and grade column will not be displayed
      showBackButton,
      enableBreadCrumbs,
      organizationId,
      grades,
      onBackClick,
      setPreviewId,
      selectedTaggedIds = [],
      openedFrom,
      customRef,
      showViewModeOnly,
      selectedNodes,
      customOnSettingsItemClick,
      addRootNodeTagging,
      isEditButtonDisabled,
      disableToolTipMsg,
      disableEditButton,
      tags,
      dummyRootNode,
      nodeEditorConfigProp,
      resolvedMinimalTreeNodes,
      showParentInsightsCount,
      shouldFilterNodesByGrades,
      isDsComponent,
      router,
      t,
      editAlertDetails,
      areOperationsDisabledForLocalisation,
      getDisabledOperationTooltip,
      /**
       * Here we are passing curriculumProgram as prop because when we open this UI via
       * links interface, we don't have currentCurriculumProgram in redux store.
       */
      curriculumProgram,
      updateIsDisabled,
      showGradeFilterExplicitly,
      excludeNodesWithExcludedChildren,
      dsVersion,
      modalHeight,
      modalWidth,
      testId,
    } = this.props;
    const {
      levelId,
      mode,
      gradeFilters,
      showDetails,
      showLockScreen,
    } = this.state;

    const rootGrades = _.get(rootNode, "grades", []);
    const showNodeTree = this.isShowNodeTree();
    const shouldRenderNewNodeEditor = this.canRenderNewNodeEditor();
    const showSaveAndExitButton =
      !_.isEqual(openedFrom, ELEMENT_TYPE_UNIT_PLAN) ||
      _.isEqual(nodeType, ELEMENT_TYPE_MYP_RELATED_CONCEPT) ||
      _.isEqual(nodeType, ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT);

    const showTitleAsDropdown = !_.isEqual(openedFrom, ELEMENT_TYPE_UNIT_PLAN);

    const innerContainerStyle = classNames({
      [classes.innerContainer]: dsVersion !== "2.0",
      [classes.innerContainerNodeEditor]: shouldRenderNewNodeEditor,
    });

    const rootNodeLabel = _.get(rootNode, "label", "");

    const isSyncSubject = _.get(rootNode, "isSyncSubject", false);
    const isLearningOutcomeEditEnabled = ACLStore.can("MapleBear:EnableLOEdit");
    const shouldBypassDisable = isSyncSubject || isLearningOutcomeEditEnabled;

    const isDsV2 = dsVersion === "2.0";

    const FooterCompV2 = (
      <Modal.Footer hasSeparator={true}>
        <div className={classes.footerV2}>
          <div className={classNames(classes.selectedCountV2, "text-label")}>
            {this.state.selectedCount
              ? nodeType === "MYP_OBJECTIVES"
                ? t("common:objectivesSelected", {
                    count: this.state.selectedCount,
                  })
                : t("common:skillsSelected", {
                    count: this.state.selectedCount,
                  })
              : null}
          </div>
          <div className={classes.footerContainerV2}>
            <Button
              size="medium"
              variant="neutral"
              type="outlined"
              onClick={() => {
                onBackClick();
              }}
              dsVersion="2.0"
            >
              {t("common:cancel")}
            </Button>
            <Button
              variant="primary"
              type="fill"
              shortcut={SHIFT_ENTER_SUBMIT_SHORTCUT}
              size="medium"
              onClick={() => {
                this.onSubmitClick({ shouldCloseModal: true });
              }}
              dsVersion="2.0"
            >
              {value?.length ? t("common:update") : t("common:done")}
            </Button>
          </div>
        </div>
      </Modal.Footer>
    );

    return (
      <ConditionalWrapper
        type={"wrapperAsElement"}
        condition={true}
        wrapper={
          isDsV2 ? (
            <Modal
              width={modalWidth}
              height={modalHeight}
              onClose={onBackClick}
            />
          ) : (
            <div className={innerContainerStyle} />
          )
        }
      >
        {!hideHeader && !shouldRenderNewNodeEditor ? (
          isDsV2 ? (
            <Modal.Header
              title={
                !_.isEmpty(rootNodeLabel)
                  ? rootNodeLabel
                  : plannerElementSetTopLabel
              }
              subtitle={label}
              hasSeparator={true}
            />
          ) : (
            <TopHeader
              title={
                !_.isEmpty(rootNodeLabel)
                  ? rootNodeLabel
                  : plannerElementSetTopLabel
              }
              showEditButton={!isDsComponent ? showEditButton : false}
              disableEditButton={disableEditButton}
              onClickChoose={onClickChoose}
              isSetPreview={isSetPreview}
              subTitle={label}
              onBackClick={this.onBackClick}
              showBackButton={!isDsComponent ? showBackButton : false}
              changeTab={this.onTabChange}
              currentTab={levelId}
              tabs={tabs}
              onChangeMode={this.onChangeMode}
              mode={mode}
              grades={rootGrades}
              gradeFilters={gradeFilters}
              updateGradeFilters={this.updateGradeFilters}
              loginActiveTab={loginActiveTab}
              onSaveClick={this.onSubmitClick}
              // onSaveClick={this.onBackClick}
              isTagging={!isDsComponent ? isTagging : false}
              showNodeTree={!isDsComponent ? showNodeTree : false}
              enableBreadCrumbs={enableBreadCrumbs}
              description={this.getDescriptionText()}
              editRootNode={editRootNode}
              onConceptualUnderStandingCheckBoxClick={
                this.onConceptualUnderStandingCheckBoxClick
              }
              isAdmin={isAdmin}
              showDetails={showDetails}
              isDsComponent={isDsComponent}
              onCloseModal={onBackClick}
              showSaveAndExitButton={showSaveAndExitButton}
              showTitleAsDropdown={showTitleAsDropdown}
              areOperationsDisabledForLocalisation={
                areOperationsDisabledForLocalisation
              }
              getDisabledOperationTooltip={getDisabledOperationTooltip}
              testId={`${testId}-topHeader`}
              shouldBypassDisable={shouldBypassDisable}
            />
          )
        ) : null}
        <ConditionalWrapper
          type={"wrapperAsElement"}
          condition={isDsV2}
          wrapper={<Modal.Body isScrollable={true} style={styles.modalBody} />}
        >
          <div className={classes.contentWrapper}>
            {showLockScreen && (
              <LockedScreenWrapper
                featureKey={`SNS_EDITOR`}
                screenType={"modal"}
                onClose={this.onCloseLockScreenModal}
              />
            )}
            {showDetails ? (
              showNodeTree ? (
                shouldRenderNewNodeEditor ? (
                  <NodeEditor
                    description={this.getDescriptionText()}
                    organizationId={organizationId}
                    subject={_.get(rootNode, "subject")} // subject id required
                    nodeType={nodeType}
                    isSetPreview={isSetPreview}
                    onBackClick={onBackClick}
                    setPreviewId={setPreviewId}
                    onClickChoose={onClickChoose}
                    showEditButton={showEditButton}
                    loginActiveTab={loginActiveTab}
                    openedFrom={openedFrom}
                    grades={grades} // grades coming from the parent component (like BenchmarksModal in UnitPlan gives the grade the unit is in)
                    selectedTaggedIds={selectedTaggedIds}
                    updateValueLocally={updateValueLocally}
                    onSubmitClick={this.onSubmitClickV2}
                    value={value}
                    customRef={customRef}
                    showViewModeOnly={showViewModeOnly}
                    uptoDepth={uptoDepth}
                    selectedNodes={selectedNodes}
                    customOnSettingsItemClick={customOnSettingsItemClick} // on settings item click for planner elements
                    addRootNodeTagging={addRootNodeTagging} // true for planner elements to add subject node to nodes array for editor
                    isEditButtonDisabled={disableEditButton}
                    disableToolTipMsg={disableToolTipMsg}
                    tags={tags}
                    dummyRootNode={dummyRootNode}
                    nodeEditorConfigProp={nodeEditorConfigProp}
                    plannerElementSetConfig={plannerElementSetConfig}
                    resolvedMinimalTreeNodes={resolvedMinimalTreeNodes}
                    router={router}
                    showTitleAsDropdown={showTitleAsDropdown}
                    curriculumProgram={curriculumProgram}
                    isSyncSubject={isSyncSubject}
                    searchText={this.props.searchText}
                    updateIsDisabled={updateIsDisabled}
                    testId={`${testId}-nodeEditor`}
                    shouldBypassDisable={shouldBypassDisable}
                  />
                ) : (
                  <NodeTreeEditor
                    updateRef={this.updateNodeTreeRef}
                    isTagging={isTagging}
                    showInsights={showInsights}
                    insightsData={insightsData}
                    nodes={nodes}
                    showOutline={showOutline}
                    startDepth={startDepth}
                    nodeType={nodeType}
                    mode={mode}
                    gradeFilters={gradeFilters}
                    updateGradeFilters={this.updateGradeFilters}
                    rootOptionsGrades={rootGrades}
                    value={value}
                    updateValueLocally={updateValueLocally}
                    rootNode={rootNode}
                    onChangeMode={this.onChangeMode}
                    onBackConfirmClick={this.onBackConfirmClick}
                    theme={theme || {}}
                    uptoDepth={uptoDepth}
                    nodeParentType={nodeParentType} //TODO: remove,we may not need this as we're already transforming associatedParent as node.grades for each node
                    showSearchHeader={showSearchHeader}
                    showSelectedCount={showSelectedCount}
                    multiSelectConfig={multiSelectConfig}
                    nodeRenderType={nodeRenderType}
                    onSubmitClick={this.onSubmitClick}
                    shouldSaveOnUpdate={shouldSaveOnUpdate}
                    showGrade={showGrade}
                    plannerElementSetConfig={plannerElementSetConfig}
                    showParentInsightsCount={showParentInsightsCount}
                    shouldFilterNodesByGrades={shouldFilterNodesByGrades}
                    isDsComponent={isDsComponent}
                    updateSelectedCount={this.updateSelectCount}
                    searchText={this.props.searchText}
                    openedFrom={openedFrom}
                    updateIsDisabled={updateIsDisabled}
                    showGradeFilterExplicitly={showGradeFilterExplicitly}
                    excludeNodesWithExcludedChildren={
                      excludeNodesWithExcludedChildren
                    }
                    dsVersion={dsVersion}
                    subtypes={plannerElementSetConfig?.filters?.subTypes}
                    testId={`${testId}-nodeTreeEditor`}
                  />
                )
              ) : (
                <LevelEditor
                  nodes={
                    nodeParentType === "PLANNER_ELEMENT"
                      ? getCombinedNodes({ nodes, subject: rootNode })
                      : nodes
                  }
                  levelId={levelId}
                  levels={levels}
                  rootNode={rootNode}
                  grades={organizationGrades}
                  gradeFilters={gradeFilters}
                  nodeSet={nodeSet}
                  mode={mode}
                  nodeParentType={nodeParentType}
                  nodeType={nodeType}
                  routeLabel={label}
                  plannerElementSetConfig={plannerElementSetConfig}
                  showGrade={showGrade}
                  alertMessage={editAlertDetails}
                />
              )
            ) : (
              <Loading />
            )}
          </div>
        </ConditionalWrapper>
        {isDsComponent ? (
          isDsV2 ? (
            FooterCompV2
          ) : (
            <div className={classes.footer}>
              <div className={classes.selectedCount}>
                {this.state.selectedCount
                  ? nodeType === "MYP_OBJECTIVES"
                    ? t("common:objectivesSelected", {
                        count: this.state.selectedCount,
                      })
                    : t("common:skillsSelected", {
                        count: this.state.selectedCount,
                      })
                  : null}
              </div>
              <div className={classes.footerContainer}>
                <Button
                  variant={"outlined-subtle"}
                  size="medium"
                  style={{
                    marginRight: "16px",
                  }}
                  onClick={() => {
                    onBackClick();
                  }}
                  disabled={false}
                >
                  {t("common:cancel")}
                </Button>
                <Button
                  variant={"progressive"}
                  size="medium"
                  onClick={() => {
                    this.onSubmitClick({ shouldCloseModal: true });
                  }}
                  disabled={false}
                >
                  {value?.length ? t("common:update") : t("common:done")}
                </Button>
              </div>
            </div>
          )
        ) : null}
      </ConditionalWrapper>
    );
  }
}

const mapActionCreators = {
  goToBack,
  updateSubjectItem,
  updateSnsSettingsAction,
  goToRelativeRoute,
  resetNodeEditorState,
  setGlobalTrayEnabledState,
  hideIntercom,
  showIntercom,
  getDisabledOperationTooltip,
};

const mapStateToProps = (state, ownProps) => {
  const {
    nodeSet,
    params,
    organizationGrades,
    nodeType,
    rootNodes,
    rootNode: currentRootNode,
    subjectId,
    useBenchmarkSetQuery,
    rootNodeId,
    setPreviewId,
    depthLabels,
    cardType,
    resolvedMinimalTreeNodes,
  } = ownProps;
  const { nodeId: paramNodeId } = params || {};
  const nodeId = paramNodeId || _.get(currentRootNode, "id", "") || rootNodeId;

  const rootNode = currentRootNode || {
    ..._.find(rootNodes, item => item.rootNodeId == nodeId),
    id: nodeId,
  };

  const rootLevels =
    cardType == "ATLS" ? depthLabels : _.get(rootNode, "levels", []);
  const levels = _.slice(rootLevels, 1, rootLevels.length);
  let nodes = [];

  /**
   * initial value for startDepth must be null, as this is required in NodeTreeEditor
   */
  let startDepth = null,
    showOutline;

  const shouldUseResolvedMinimalTreeNodes = !_.isEmpty(
    resolvedMinimalTreeNodes
  );

  if (nodeType == "ATL" && useBenchmarkSetQuery) {
    nodes = _.filter(
      nodeSet.nodes,
      ({ atlCategory }) => atlCategory.id == nodeId
    );
  }

  if (shouldUseResolvedMinimalTreeNodes) {
    nodes = addGradesToNodes({ nodes: resolvedMinimalTreeNodes });
    startDepth = getStartDepth({ nodes, rootNode });
    showOutline = getShowOutlineStatus({ nodes, startDepth });
  }

  //added myp learning standard and ubd learning stadnard here
  const isNewPlannerElementEditor = _.includes(
    [
      ELEMENT_TYPE_MYP_LEARNING_STANDARD,
      ELEMENT_TYPE_UBD_LEARNING_STANDARD,
      ELEMENT_TYPE_DP_SYLLABUS,
      ELEMENT_TYPE_DP_SUBJECT_STANDARD,
      ELEMENT_TYPE_DP_KNOWLEDGE_FRAMEWORK,
    ],
    nodeType
  );

  const activeTab = getActiveTab(state);

  const isAccountSettingsTab = activeTab === "accountSettingsTab";

  const curriculumProgramId = isAccountSettingsTab
    ? getCurriculumProgramIdFromCurrentAdminNavigationNode(state)
    : getSelectedCurriculumId(state);

  const tabConfigurations = { admin: { curriculumProgramId } };

  const isCurriculumProgramFree = getCurriculumProgramFreeStatus({
    state,
    tabConfigurations,
  });

  // checking for academic setup access as this condition is used to check if modify button is enabled
  const isAdmin = getIsAcademicSetupEnabledForCurriculum({
    curriculumProgramId,
  });

  return {
    isData: true,
    isLoading: false,
    organizationId: state.login.userInfo.org_id,
    nodeId: nodeId,
    editRootNode: _.get(state, "multiLevelNodeEditor.rootNode", {}),
    // Re-evaluate rootNode only when organizationGrades are provided in props
    rootNode: !_.isUndefined(organizationGrades)
      ? getUpdatedRootNodeMemoize({
          rootNode,
          organizationGrades,
          subjectId,
        })
      : rootNode,
    isAdmin,
    tabs: getTabsMemoize(levels),
    nodes: orderBySequenceNodesMemoize(nodes),
    levels: levels,
    nodeSet: nodeSet,
    isCurriculumProgramFree,
    loginActiveTab: state.login.activeTab,
    isNewPlannerElementEditor,
    setPreviewId,
    startDepth,
    showOutline,
    shouldUseResolvedMinimalTreeNodes,
    curriculumProgramId,
  };
};

const LevelsWrapper = compose(
  I18nHOC({ resource: ["common"] }),
  withRouter,
  connect(mapStateToProps, mapActionCreators),
  graphql(getOrganizationGradeBasicDetailsQuery, {
    name: "getOrganizationGrades",
    skip: ({ organizationGrades, nodeType }) =>
      _.get(organizationGrades, "length", 0) > 0 ||
      _.includes(
        [ELEMENT_TYPE_DP_SYLLABUS, ELEMENT_TYPE_DP_KNOWLEDGE_FRAMEWORK],
        nodeType
      ),
    options: ({ organizationId, organizationGradesFilter }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        organizationId,
        filters: organizationGradesFilter,
      },
    }),
    props({
      getOrganizationGrades,
      ownProps: {
        rootNode,
        isData,
        isLoading,
        organizationId,
        subjectId,
        organizationGradesFilter,
        gradeFilters,
        populateRootNodeWithGrades,
      },
    }) {
      const queryData = getOrganizationBasicGradeDetailsFromCache({
        organizationId,
        filters: organizationGradesFilter,
      });
      const organizationGrades = _.get(queryData, "grades", []);
      if (populateRootNodeWithGrades) {
        rootNode = update(rootNode, {
          grades: {
            $set: organizationGrades,
          },
        });
      }
      if (gradeFilters) {
        gradeFilters = _.filter(organizationGrades, orgGrades =>
          _.includes(gradeFilters, _.get(orgGrades, "id", ""))
        );
      }
      return {
        rootNode: getUpdatedRootNodeMemoize({
          rootNode,
          organizationGrades,
          subjectId,
        }),
        gradeFilters,
        organizationGrades,
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          getOrganizationGrades["networkStatus"] == 1 ||
          getOrganizationGrades["networkStatus"] == 2 ||
          getOrganizationGrades["networkStatus"] == 4 ||
          isLoading,
      };
    },
  }),
  graphql(getATLsQuery, {
    name: "getALTs",
    skip: ({ nodeId, useBenchmarkSetQuery, nodeType }) =>
      !nodeId || nodeType !== "ATL" || useBenchmarkSetQuery,
    options: ({ nodeId, grades }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: nodeId,
        grades,
      },
    }),
    props({
      getALTs,
      ownProps: { isData, isLoading, grades, nodeId, selectedNodes },
    }) {
      const queryData = getATLsFromCache({
        id: nodeId,
        grades,
      });

      const mergedNodes = mergeSelectedNodesMemoize({
        nodes: _.get(queryData, "atls", []),
        selectedNodes: selectedNodes,
      });

      return {
        nodes: mergedNodes,
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          getALTs["networkStatus"] == 1 ||
          getALTs["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getSubjectBenchmarksQuery, {
    name: "getSubjectBenchmarks",
    skip: ({
      nodeType,
      isSetPreview,
      rootNode: { subject },
      useBenchmarkSetQuery,
    }) =>
      nodeType != "BENCHMARK" ||
      isSetPreview ||
      !subject ||
      useBenchmarkSetQuery,
    options: ({ rootNode: { subject } = {} }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        subject,
      },
    }),
    props({
      getSubjectBenchmarks,
      ownProps: { isData, isLoading, rootNode, uptoDepth, selectedNodes },
    }) {
      const queryData = getSubjectBenchmarksFromCache({
        subject: _.get(rootNode, "subject", ""),
      });
      const benchmarks = mergeSelectedNodesMemoize({
        nodes: _.get(queryData, "benchmarks", []),
        selectedNodes: updateSelectedNodesTypeMemoize({
          rootNode,
          selectedNodes,
        }),
      });
      const nodeSet = getPYPElementSetFromNodes({
        nodes: benchmarks,
      });
      const rootNodes = _.get(nodeSet, "rootNodes", []);
      const nodes = _.get(nodeSet, "nodes", []);

      return {
        nodeSet,
        rootNodes,
        nodes: !uptoDepth
          ? nodes
          : _.filter(nodes, item => item.depth <= uptoDepth),
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          getSubjectBenchmarks["networkStatus"] == 1 ||
          getSubjectBenchmarks["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),

  graphql(getPlannerElementNodesOfSetQuery, {
    name: "getPlannerElementNodesOfSet",
    skip: ({
      nodeParentType,
      isNewPlannerElementEditor,
      nodeType,
      shouldUseResolvedMinimalTreeNodes,
    }) =>
      nodeParentType != "PLANNER_ELEMENT" || //TODO: USE STRING consts preferably. CTRL + F to search we've already used it twice in this component and inside other components down the tree
      isNewPlannerElementEditor ||
      shouldUseResolvedMinimalTreeNodes,
    options: ({ plannerElementSetConfig: { id, filters } = {} }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id,
        filters,
      },
    }),
    props({
      getPlannerElementNodesOfSet,
      ownProps: {
        nodeType,
        rootNode,
        isData,
        isLoading,
        plannerElementSetConfig: { id, filters } = {},
      },
    }) {
      const plannerElementSetData = getPlannerElementNodesOfSetFromCache({
        id,
        filters,
      });

      const plannerElementNodes = _.get(plannerElementSetData, "nodes", []);
      const plannerElementSetTopLabel = _.get(
        plannerElementSetData,
        "label",
        ""
      );

      let nodes = addGradesToNodes({
        nodes: plannerElementNodes,
      });

      nodes = modifyNodeDepthByNodeType({ nodes, nodeType });

      const startDepth = getStartDepth({
        nodes,
        rootNode,
      });

      const showOutline =
        getShowOutlineStatus({ nodes, startDepth }) ||
        (ACLStore.can(ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION) &&
          _.isEqual(nodeType, ELEMENT_TYPE_MYP_OBJECTIVES) &&
          !filters?.subtypes);

      return {
        startDepth,
        showOutline,
        nodes,
        plannerElementSetTopLabel,
        isData: !_.isEmpty(plannerElementSetData) && isData,
        isLoading:
          getPlannerElementNodesOfSet["networkStatus"] == 1 ||
          getPlannerElementNodesOfSet["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  withLoader,
  withQueryParamsBasedInterface({ cb: getLevelsProps })
)(Levels);

export default LevelsWrapper;

LevelsWrapper.defaultProps = {
  startDepth: null,
  showSearchHeader: true,
  shouldSaveOnUpdate: true,
  showGrade: true,
  shouldFilterNodesByGrades: true,
  nodeEditorConfigProp: {},
  resolvedMinimalTreeNodes: [],
  organizationGradesFilter: {},
  showGradeFilterExplicitly: false,
  excludeNodesWithExcludedChildren: false,
  dsVersion: "1.0",
  modalHeight: "calc(100vh - 128px)",
  modalWidth: "calc(100vw - 128px)",
};
